import { CustomDashboardActionProps } from './Dashboard.types'

export const CustomDashboardAction: React.FC<CustomDashboardActionProps> = (
  props
) => {
  const { children } = props

  return <div className='action-wrapper'>{children}</div>
}
